import { Step6_off, Step6_on, Step7_off, Step7_on, Step5_off, Step5_on, Step4_off, Step4_on, Step3_off, Step3_on, Step2_off, Step2_on, Step1_off, Step1_on, } from 'assets'
import { assessment_progress1, assessment_progress2, assessment_progress3 } from 'introductions'

const useRating = () => {

    const ratings = {
        "1": {
            iconOn: Step1_on,
            iconOff: Step1_off,
            text: "איזה הצלחה",
            step: "ראשון",
            audio: assessment_progress2
        },
        "2": {
            iconOn: Step2_on,
            iconOff: Step2_off,
            text: "איזה אליפות",
            step: "שני",
            audio: assessment_progress3

        },
        "3": {
            iconOn: Step3_on,
            iconOff: Step3_off,
            text: "עוד שלב שכבשת",
            step: "שלישי",
            audio: assessment_progress1
        },
        "4": {
            iconOn: Step4_on,
            iconOff: Step4_off,
            text: "אין עליך",
            step: "רביעי",
            audio: assessment_progress3
        },
        "5": {
            iconOn: Step5_on,
            iconOff: Step5_off,
            text: "כשרון",
            step: "חמישי",
            audio: assessment_progress3
        },
        "6": {
            iconOn: Step6_on,
            iconOff: Step6_off,
            text: "אנחנו כבר מעט גומרים",
            step: "שישי",
            audio: assessment_progress1
        }
    }

    return ratings
}

export default useRating